import { getDocs, collection, query, where } from "@firebase/firestore";
import { hideLoading, setForRentCostumesList, showLoading } from "./for-rent-costumes-list-slice";
import { showErrorSnackbar } from "../../../../shared/snackbar/snackbar-slice";

export const getForRentCostumesService = async (dispatch, db, coll) => {
    try {
        dispatch(showLoading());
        const querySnapshot = await getDocs(
            query(collection(db, coll), where("type", "==", "For rent"), where("category", "==", "Costume"))
        );
        const data = querySnapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
        }));
        dispatch(setForRentCostumesList(data));
        dispatch(hideLoading());
    } catch (e) {
        dispatch(showErrorSnackbar('Fetch failed! Please try again.'))
        console.error("ForRentCostumesList getForRentCostumesService error: ", e);
    }
};